<template>
  <div class="my-bookings">

    <!-- === Loader Overlay === -->
    <transition name="fade-slide">
      <div v-if="isLoading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>

    <!-- ===== Row 1: KPI Count Cards ===== -->
    <div class="kpi-row fade-in">
      <div class="kpi-card" v-for="(kpi, i) in bookingStats" :key="i">
        <div>
          <h4>{{ kpi.title }}</h4>
          <div class="value">{{ kpi.value }}</div>
        </div>
        <i :class="kpi.icon + ' kpi-icon'"></i>
      </div>
    </div>

    <!-- ===== Row 2: Filters & Header ===== -->
    <div class="grid-header fade-in">
      <div class="filters">
        <div class="search-box">
          <i class="bx bx-search"></i>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Search bookings..."
            @keyup.enter="fetchBookings"
          />
        </div>

        <select v-model="selectedStatus" @change="fetchBookings">
          <option value="">All Status</option>
          <option value="Pending">Pending</option>
          <option value="Completed">Completed</option>
          <option value="Canceled">Canceled</option>
        </select>

        <select v-model="selectedLocation" @change="fetchBookings">
          <option value="">All Locations</option>
          <option value="Zoom Call">Zoom Call</option>
          <option value="Google">Google Meet</option>
          <option value="In-Person Meeting">In-Person Meeting</option>
          <option value="Phone Call">Phone Call</option>
          <option value="Request Location">Request Location</option>
          <option value="Custom Location">Custom Location</option>
          <option value="No Location">No Location</option>
        </select>
      </div>

     
    </div>

    <!-- ===== Row 3: Booking Cards ===== -->
    <div v-if="bookings.length > 0" class="website-grid fade-in">
      <div class="website-card" v-for="booking in bookings" :key="booking.id">
        <div class="website-card-header">
          <h4><i class="bx bx-calendar-event"></i> {{ booking.title }}</h4>

          <div class="card-menu">
            <i class="bx bx-dots-vertical-rounded"></i>
            <div class="card-menu-dropdown">
              <button title="Start Meeting" @click="start_meeet(booking.meet_link)"><i class="bx bx-play-circle"></i> Start</button>
              <!-- <button title="View Booking" @click="bookrepnow(booking.id)"><i class="bx bx-show"></i> View</button> -->
              <button title="Send Reminder"><i class="bx bx-bell"></i> Remind</button>
              <button
                v-if="booking.status==='Pending'"
                title="Cancel Booking"
                @click="changeBookingStatus(booking, 'Canceled')"
              >
                <i class="bx bx-x-circle"></i> Cancel
              </button>
               <button
                v-if="booking.status==='Pending'"
                title="Complete Booking"
                @click="changeBookingStatus(booking, 'Completed')"
              >
                <i class="bx bx-check"></i> Complete
              </button>
              <button title="Reschedule" @click="openRescheduleModal(booking)"><i class="bx bx-calendar-edit"></i> Reschedule</button>
              <button
                title="Delete Booking"
                style="color: #991b1b;"
                @click="deleteBooking(booking)"
              >
                <i class="bx bx-trash"></i> Delete
              </button>
            </div>
          </div>
        </div>

        <div class="website-card-body">
          <div class="booking-meta">
            <div><i class="bx bx-time-five"></i> {{ booking.time }}</div>
            <div><i class="bx bx-user"></i> {{ booking.person }}</div>
            <div><i class="bx bx-map"></i> {{ booking.location }}</div>
          </div>

          <p>{{ booking.report }}</p>

          <div class="booking-stats">
            <span class="status" :class="booking.status.toLowerCase()">
              <i v-if="booking.status === 'Completed'" class="bx bx-check-circle"></i>
              <i v-else-if="booking.status === 'Pending'" class="bx bx-time-five"></i>
              <i v-else-if="booking.status === 'Active'" class="bx bx-bolt-circle"></i>
              <i v-else-if="booking.status === 'Canceled'" class="bx bx-x-circle"></i>
              {{ booking.status }}
            </span>

            <span class="payment" :class="booking.paymentStatus.toLowerCase()">
              <i
                v-if="booking.paymentStatus === 'Paid'"
                class="bx bx-dollar-circle"
              ></i>
              <i
                v-else-if="booking.paymentStatus === 'Unpaid'"
                class="bx bx-credit-card-front"
              ></i>
              {{ booking.paymentStatus }}
            </span>
          </div>
        </div>

        <div class="website-card-footer">
          <span class="website-domain">
            <i class="bx bx-calendar"></i> {{ booking.date }}
          </span>
          <div class="footer-actions">
            <button v-if="booking.meet_link!=null" class="btn-start" @click="start_meeet(booking.meet_link)">
              <i class="bx bx-play-circle"></i> Start
            </button>
            <!-- <button class="btn-download" @click="bookrepnow(booking.id)">
              <i class="bx bx-download"></i> Report
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- ===== Placeholder when no bookings found ===== -->
    <div v-else class="placeholder-box fade-in">
      <i class="bx bx-calendar-x"></i>
      <p>No bookings found.</p>
       <button
          class="btn-primary"
          @click="addNewPage"
          style="padding: 8px 14px; font-size: 13px; border-radius: 6px; margin-top: 1rem;"
        >
          <i class="bx bx-plus" style="font-size: 14px; color: white;"></i> Create New Page
        </button>
    </div>

    <!-- ===== Pagination ===== -->
    <div v-if="bookings.length > 0" class="pagination fade-in">
      <span>
        Showing {{ startIndex + 1 }}–{{ endIndex }} of {{ totalBookings }} bookings
      </span>
      <div class="pagination-buttons">
        <button :disabled="currentPage === 1" @click="prevPage">
          <i class="bx bx-chevron-left"></i>
        </button>
        <button class="active">{{ currentPage }}</button>
        <button
          :disabled="endIndex >= bookings.length"
          @click="nextPage"
        >
          <i class="bx bx-chevron-right"></i>
        </button>
      </div>
    </div>
<!-- ============================
     RESCHEDULE MODAL
============================= -->
<div v-if="showReschedule" class="modal-overlay fade-in">
  <div class="modal-box">
    <h3 class="modal-title">Reschedule Appointment</h3>

    <div class="form-group">
      <label>New Date</label>
      <input type="date" v-model="newDate" @change="loadNewSlots" />
    </div>

    <div class="form-group">
      <label>New Slot</label>
      <select v-model="newSlot">
        <option value="">Select Slot</option>
        <option
          v-for="(s,i) in newSlots"
          :key="'s'+i"
          :value="s.label"
        >
          {{ check_timezone(s.label,s.business_timezone) }}
        </option>
      </select>
    </div>

    <div class="modal-actions">
      <button class="btn-secondary" @click="closeRescheduleModal">Cancel</button>
      <button class="btn-primary" @click="confirmReschedule">Update</button>
    </div>
  </div>
</div>

    <br /><br /><br />
  </div>
</template>


<script scoped>
import { getBooks, getBookReport, deleteBook, updateBookStatus,rescheduleAppointment,getAvailableSlots } from "@/apis/bookapis";

import { useToast } from "vue-toastification";

export default {
  name: "MyBookings",
  data() {
    return {
      
      showReschedule: false,
      activeBooking: null,
      newDate: "",
      newSlot: "",
      newSlots: [],
      isLoading: false,
      searchQuery: "",
      selectedStatus: "",
      selectedLocation: "",
      currentPage: 1,
      perPage: 6,

      bookings: [],
      totalBookings: 0,

      bookingStats: [
        { title: "Total Bookings", value: 0, icon: "bx bx-book-content" },
        { title: "Pending", value: 0, icon: "bx bx-time-five" },
        { title: "Completed", value: 0, icon: "bx bx-check-circle" },
        { title: "Canceled", value: 0, icon: "bx bx-x-circle" },
      ],
    };
  },

  computed: {
   
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.perPage, this.bookings.length);
    },
  },

  mounted() {
    this.fetchBookings();
    this.fetchBookingReport();
  },

  methods: {
    
    addNewPage() {
      sessionStorage.removeItem("booking_page_data");
      this.$router.push("/add_booking_page");
    },
    check_timezone(label,vendor_zone){
    if (!label) return "";

    let curr_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    

    if (vendor_zone === "Asia/Calcutta") vendor_zone = "Asia/Kolkata";
    if (curr_timezone === "Asia/Calcutta") curr_timezone = "Asia/Kolkata";

    const [startStr, endStr] = label.split(" - ");

    const today = new Date().toISOString().split("T")[0];

    const startVendor = new Date(
        new Date(`${today} ${startStr}`).toLocaleString("en-US", { timeZone: vendor_zone })
    );

    const endVendor = new Date(
        new Date(`${today} ${endStr}`).toLocaleString("en-US", { timeZone: vendor_zone })
    );

    const startUser = new Date(startVendor.toLocaleString("en-US", { timeZone: curr_timezone }));
    const endUser = new Date(endVendor.toLocaleString("en-US", { timeZone: curr_timezone }));

    const fmt = (d) =>
        d.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });

    return `${fmt(startUser)} - ${fmt(endUser)}`;
},
    start_meeet($page_url){
      window.open($page_url, "_blank");
    },
    openRescheduleModal(booking) {
    this.activeBooking = booking;
    this.showReschedule = true;
  },

  closeRescheduleModal() {
    this.showReschedule = false;
    this.newDate = "";
    this.newSlot = "";
    this.newSlots = [];
  },

  async loadNewSlots() {
    if (!this.newDate) return;

    const res = await getAvailableSlots(
      this.activeBooking.page_id,
      this.newDate
    );

    if (res.status) this.newSlots = res.slots;
  },

  async confirmReschedule() {
    const toast = useToast();

    if (!this.newDate || !this.newSlot) {
      toast.warning("Please select date & time");
      return;
    }

    const res = await rescheduleAppointment(
      this.activeBooking.id,
      this.newDate,
      this.newSlot
    );

    if (res.status) {
      toast.success("Appointment rescheduled successfully");
      this.fetchBookings();
      this.fetchBookingReport();
      this.closeRescheduleModal();
    } else {
      toast.error(res.success);
    }
  }
  ,
    async fetchBookings() {
      const toast = useToast();
      try {
        this.isLoading = true;
        const ldata = JSON.parse(sessionStorage.getItem("ldata"));
        const vendorId = ldata?.user_id;

        const res = await getBooks(
          vendorId,
          this.selectedStatus,
          "",
          this.selectedLocation,
          this.currentPage - 1,
          this.searchQuery
        );

        if (res.status && Array.isArray(res.records)) {
          this.bookings = res.records.map(r => ({
            id: r.appointment_id,
            title: r.appointment_page_title,
            meet_link: r.appointment_meet,
            page_id: r.appointment_page,
            time: r.appointment_slot,
            person: r.appointment_name,
            location: r.appointment_location || "No Location",
            status: r.appointment_status,
            paymentStatus: r.appointment_payment_status,
            date: r.appointment_date,
            report: r.package_name || "",
            appointment_mode: r.appointment_payment_mode, // for filter match
            appointment_page_title: r.appointment_page_title, // for search match
          }));

          this.totalBookings = res.total1 || this.bookings.length;
        } else {
          this.bookings = [];
          toast.warning("No bookings found.");
        }
      } catch (e) {
        console.error("fetchBookings error:", e);
        toast.error("Failed to load bookings");
      } finally {
        this.isLoading = false;
      }
    },

    async fetchBookingReport() {
      try {
        const ldata = JSON.parse(sessionStorage.getItem("ldata"));
        const vendorId = ldata?.user_id;

        const res = await getBookReport(vendorId);
        if (res.status) {
          this.bookingStats = [
            { title: "Total Bookings", value: res.total, icon: "bx bx-book-content" },
            { title: "Pending", value: res.pending, icon: "bx bx-time-five" },
            { title: "Completed", value: res.completed, icon: "bx bx-check-circle" },
            { title: "Canceled", value: res.canceled, icon: "bx bx-x-circle" },
          ];
        }
      } catch (e) {
        console.error("fetchBookingReport error:", e);
      }
    },

    async deleteBooking(booking) {
      const toast = useToast();
      if (!confirm(`Are you sure you want to delete "${booking.title}"?`)) return;
      try {
        this.isLoading = true;
        const res = await deleteBook(booking.id);
        if (res.status) {
          toast.success("Booking deleted successfully");
          this.fetchBookings();
          this.fetchBookingReport();
        } else {
          toast.error(res.success || "Failed to delete booking");
        }
      } catch (e) {
        console.error("deleteBooking error:", e);
        toast.error("Delete failed");
      } finally {
        this.isLoading = false;
      }
    },

    async changeBookingStatus(booking, newStatus) {
      const toast = useToast();
      try {
        this.isLoading = true;
        const res = await updateBookStatus(booking.id, newStatus);
        if (res.status) {
          toast.success(`Status updated to ${newStatus}`);
          this.fetchBookings();
          this.fetchBookingReport();
        } else {
          toast.error(res.success || "Status update failed");
        }
      } catch (e) {
        console.error("updateBookStatus error:", e);
        toast.error("Failed to update status");
      } finally {
        this.isLoading = false;
      }
    },

    nextPage() {
      if (this.endIndex < this.bookings.length) {
        this.currentPage++;
        this.fetchBookings();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchBookings();
      }
    },
  },
};
</script>


<style scoped>
/* === Fade Animation === */
.fade-in {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
  transform: translateY(10px);
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Filters === */
.filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.filters select {
  padding: 6px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 13px;
}

/* === Booking Cards === */
.website-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 20px;
  justify-content: center;
}

/* Limit max width of each card */
.website-card {
  width: 100%;
  margin: 0 auto;      /* center inside grid block */
}
.booking-meta {
  display: flex;
  justify-content: space-between;
  color: var(--muted);
  font-size: 13px;
  margin-bottom: 8px;
}
.booking-meta i {
  margin-right: 5px;
  color: var(--primary);
}
.booking-stats {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.status,
.payment {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}
.status.completed {
  background: #dcfce7;
  color: #166534;
}
.status.pending {
  background: #fef3c7;
  color: #92400e;
}
.status.active {
  background: #dbeafe;
  color: #1e3a8a;
}
.status.canceled {
  background: #fee2e2;
  color: #991b1b;
}
.payment.paid {
  background: #e0f2fe;
  color: #0369a1;
}
.payment.unpaid {
  background: #fee2e2;
  color: #991b1b;
}

/* === Card Menu Dropdown === */
.card-menu {
  position: relative;
}
.card-menu i {
  cursor: pointer;
  font-size: 1.2rem;
}
.card-menu-dropdown {
  position: absolute;
  right: 0;
  top: 1.5rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: none;
  flex-direction: column;
  z-index: 99999999;
}
.card-menu:hover .card-menu-dropdown {
  display: flex;
}
.card-menu-dropdown button {
  border: none;
  background: none;
  text-align: left;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.25s ease;
}
.card-menu-dropdown button:hover {
  background: #f3f4f6;
}

/* === Pagination === */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}
.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}
.pagination-buttons button {
  border: none;
  background: #f3f4f6;
  color: var(--text);
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.pagination-buttons button.active {
  background: var(--primary);
  color: #fff;
}
.pagination-buttons button:hover {
  background: var(--primary);
  color: #fff;
}
/* === Footer Buttons (Start + Report) === */
.footer-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-start,
.btn-download {
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.btn-start {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 2px 6px rgba(17, 24, 39, 0.2);
}

.btn-start:hover {
  background: #1e3a8a;
  transform: translateY(-1px);
}

.btn-download {
  background: #f3f4f6;
  color: var(--text);
}

.btn-download:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* === Status + Payment Icons Alignment === */
.booking-stats i {
  margin-right: 6px;
  vertical-align: middle;
  font-size: 1rem;
}

/* === Footer Alignment Fix === */
.website-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--border);
  padding-top: 10px;
  margin-top: 10px;
}
/* ==========================================================
   📱 RESPONSIVE FIXES — My Bookings Page
   ========================================================== */

@media (max-width: 1024px) {
  /* KPI Row */
  .kpi-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px !important;
  }
  .kpi-card {
    flex: 1 1 48% !important;
    min-width: 250px !important;
  }

  /* Filters + Search */
  .grid-header {
    display: flex;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
  }
  .filters {
    width: 100% !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }
  .filters select,
  .filters input,
  .filters .search-box {
    flex: 1 1 48% !important;
    min-width: 160px !important;
  }
  .grid-header .btn-primary {
    align-self: stretch !important;
    width: 100% !important;
  }

  /* Booking Grid */
  .website-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;
    gap: 16px !important;
     overflow: visible !important;
  }
  .website-card {
    padding: 14px !important;
  }
}

@media (max-width: 768px) {
  /* KPI Cards Stack */
  .kpi-row {
    flex-direction: column !important;
    gap: 12px !important;
  }
  .kpi-card {
    min-width: 100% !important;
  }

  /* Filters */
  .filters {
    flex-direction: column !important;
    align-items: flex-start !important;
    width: 100% !important;
  }
  .filters .search-box,
  .filters select {
    width: 100% !important;
  }

  .grid-header {
    flex-direction: column !important;
    gap: 12px !important;
  }
  .grid-header .btn-primary {
    width: 100% !important;
    padding: 10px 0 !important;
  }

  /* Booking Cards */
  .website-grid {
    grid-template-columns: 1fr !important;
    gap: 14px !important;
     overflow: visible !important;
  }
  .website-card {
    margin: 0 auto !important;
    width: 100% !important;
     overflow: visible !important;
  }
  .booking-meta {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 4px !important;
  }
  .booking-meta div {
    width: 100% !important;
  }
  .booking-stats {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 6px !important;
  }

  /* Footer Buttons */
  .website-card-footer {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
  }
  .footer-actions {
    width: 100% !important;
    display: flex !important;
    justify-content: flex-start !important;
    gap: 10px !important;
  }
  .footer-actions button {
    flex: 1 !important;
  }

  /* Pagination */
  .pagination {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
    margin-top: 18px !important;
  }
  .pagination-buttons {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .filters select,
  .filters input {
    font-size: 12px !important;
    padding: 6px 8px !important;
  }
  .kpi-card h4 {
    font-size: 12px !important;
  }
  .kpi-card .value {
    font-size: 16px !important;
  }

  .website-card {
    padding: 12px !important;
     overflow: visible !important;
  }
  .website-card h4 {
    font-size: 0.95rem !important;
  }
  .website-card p {
    font-size: 12.5px !important;
  }

  .footer-actions button {
    font-size: 12px !important;
    padding: 6px 10px !important;
  }

  /* Bottom padding for safe scroll space */
  .my-bookings {
    padding-bottom: 2rem !important;
  }
}

/* =====================================================
   🎨 ADDITIONAL UI PATCH — MY BOOKINGS PAGE
   ===================================================== */

/* === Loader Overlay === */
.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(3px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5000;
  animation: fadeIn 0.3s ease;
}

.loader-overlay p {
  color: var(--text);
  margin-top: 10px;
  font-size: 14px;
  font-weight: 500;
}

.spinner {
  width: 42px;
  height: 42px;
  border: 4px solid var(--border);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* === Placeholder (No Bookings) === */
.placeholder-box {
  text-align: center;
  padding: 60px 20px;
  background: var(--card);
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  color: var(--muted);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.placeholder-box i {
  font-size: 3rem;
  color: var(--primary);
  opacity: 0.85;
}

.placeholder-box p {
  margin-top: 10px;
  font-size: 14px;
  color: var(--muted);
}

/* === Card Hover & Transition Polish === */
.website-card {
  transition: all 0.25s ease;
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
   overflow: visible !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}
.website-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

/* === Smooth dropdown animation === */
.card-menu-dropdown {
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 0.25s ease;
}
.card-menu:hover .card-menu-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* === Improved search box === */
.search-box {
  display: flex;
  align-items: center;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 4px 10px;
  min-width: 200px;
  transition: all 0.3s ease;
}
.search-box i {
  font-size: 1rem;
  color: var(--muted);
  margin-right: 6px;
}
.search-box input {
  border: none;
  outline: none;
  width: 100%;
  background: transparent;
  color: var(--text);
  font-size: 13px;
}
.search-box:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* === Primary Button Polish === */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-primary:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* === Pagination Buttons Hover Fix === */
.pagination-buttons button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-buttons button:not([disabled]):hover {
  background: var(--primary);
  color: #fff;
}

/* === Accessibility: Focus States === */
button:focus,
select:focus,
input:focus {
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
}

/* === Text Wrapping Fixes === */
.website-card h4 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
   overflow: visible !important;
}

/* === Responsive Enhancements === */
@media (max-width: 768px) {
  .search-box {
    min-width: 100% !important;
  }
  .filters {
    flex-direction: column;
    align-items: flex-start;
  }
  .filters select {
    width: 100%;
  }
  .website-card {
    padding: 14px;
     overflow: visible !important;
  }
  .btn-primary {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .search-box input {
    font-size: 12.5px;
  }
  .placeholder-box {
    padding: 40px 14px;
  }
  .placeholder-box i {
    font-size: 2.2rem;
  }
  .btn-primary {
    padding: 8px 12px;
    font-size: 12.5px;
  }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
}

.modal-box {
  background: #fff;
  width: 90%;
  max-width: 420px;
  padding: 1.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15);
  animation: fadeInUp .35s ease;
}

.modal-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 1.4rem;
}

.btn-secondary {
  padding: 8px 16px;
  border: none;
  background: #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
}
/* ==========================================
   RESCHEDULE POPUP — FULL UI CSS
========================================== */



/* Modal Box */
.modal-box {
  width: 95%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 18px;
  padding: 1.7rem;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
  animation: fadeInUp 0.35s ease;
}

/* Modal Title */
.modal-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 1.2rem;
  color: var(--text);
}

/* Form Fields */
.modal-box .form-group {
  margin-bottom: 1.1rem;
}

.modal-box label {
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
  display: inline-block;
}

.modal-box input,
.modal-box select {
  width: 100%;
  padding: 0.75rem;
  border-radius: 10px;
  border: 1px solid var(--border);
  outline: none;
  background: var(--card);
  transition: 0.25s;
  font-size: 0.9rem;
}

.modal-box input:focus,
.modal-box select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

/* Modal Buttons */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 1.4rem;
}

/* Cancel Button */
.btn-secondary {
  background: #e5e7eb;
  border: none;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: 0.25s;
}

.btn-secondary:hover {
  background: #d1d5db;
}

/* Primary Button */
.modal-actions .btn-primary {
  background: #111827;
  color: white !important;
  padding: 8px 18px;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: 0.25s ease;
}

.modal-actions .btn-primary:hover {
  background: #000;
  transform: translateY(-2px);
}

/* Fade Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ==========================================
   RESPONSIVE
========================================== */

@media (max-width: 520px) {
  .modal-box {
    padding: 1.4rem;
    border-radius: 14px;
  }
  .modal-title {
    font-size: 1.2rem;
  }
  .modal-actions button {
    padding: 8px 14px;
    font-size: 0.85rem;
  }
}

</style>
